module.exports = __webpack_public_path__ + "media/images/icons/collapse-left-8a9b7b42878591fb129fb575337ba8c8.svg";